import "./ExcalidrawLogo.scss";

const LogoIcon = () => (
  <svg
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="ExcalidrawLogo-icon"
    role="img"
  >
    <path d="M50 50 A50 50 0 0 1 150 50 L150 70 L50 70 Z" fill="currentColor" />
    <path d="M50 80 A50 50 0 0 0 50 180 L70 180 L70 80 Z" fill="currentColor" />
    <path
      d="M150 80 A50 50 0 0 1 150 180 L130 180 L130 80 Z"
      fill="currentColor"
    />
  </svg>
);

const LogoText = () => (
  <svg
    viewBox="0 0 260 55"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className="ExcalidrawLogo-text"
  >
    <text
      x="0"
      y="43"
      fontFamily="Orbitron, Assistant, sans-serif"
      fontSize="46"
      fontWeight="600"
      letterSpacing="1"
      fill="currentColor"
    >
      Chartoon
    </text>
  </svg>
);

type LogoSize = "xs" | "small" | "normal" | "large" | "custom" | "mobile";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: React.CSSProperties;
  /**
   * If true, the logo will not be wrapped in a Link component.
   * The link prop will be ignored as well.
   * It will merely be a plain div.
   */
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size}`} style={style}>
      <LogoIcon />
      {withText && <LogoText />}
    </div>
  );
};
